/**
 * This component is used to create sliders with multiple images, it will automatically init all the
 * elements that contain a data-image-compare-container, it also exposes the init method in case you need to
 * dynamically add another component.
 *
 * To properly work, this components needs the following:
 * 1. to add the data-image-compare-container to the parent of the slider
 * 2. add a type="range" input with the data-image-compare-slider attribute
 * 3. 2 images, the second one needs to have the data-image-compare-overlay data attribute to properly work
 *
 * The basic structure for this can be seen below:
 *
 * <div class="design-center__visualizer-container" data-image-compare-container>
    <picture>
        <source src="image1.webp" type="image/webp">
        <source src="image1.jpg" type="image/jpeg">
        <img  src="image1.jpg" alt="">
    </picture>

    <picture>
        <source src="image1.webp" type="image/webp">
        <source src="image1.jpg" type="image/jpeg">
        <img  src="image1.jpg" alt="" data-image-compare-overlay>
    </picture>

    <label for="slider" class="visuallyhidden">Slide!</label>
    <input data-image-compare-slider type="range" min="0" max="100" value="50" step="5" id="slider">
  </div>
 */

(function imageSlider(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  /**
    * @constructs NewHomeSource.ImageSlider
    */
  function ImageSlider() {
  }

  /**
     * Function used to dynamically change the clip path for the slider to work.
     * @param {*} event
     */
  function slide(event) {
    const slider = event.target;
    const value = slider.value;
    const container = event.target.closest('[data-image-compare-container]');
    const image = container.querySelector('[data-image-compare-overlay]');

    if (image && value) {
      image.style.clipPath = `polygon(0 0,${value}% 0,${value}% 100%, 0 100%)`;
    }
  }

  function init(container) {
    container.addEventListener('input', slide);
  }

  ImageSlider.init = init;

  const sliders = document.querySelectorAll('[data-image-compare-container]');
  sliders.forEach((slider) => {
    init(slider);
  });

  global.NewHomeSource.ImageSlider = ImageSlider;
  return ImageSlider;
}(window));
